/* eslint-disable standard/object-curly-even-spacing */
import React, { useState } from "react";

import { graphql } from "react-apollo";
import gql from "graphql-tag";

import withSharedSnackbar from "../../HOCs/withSharedSnackbar";
import { Modal,  Typography, Button, CircularProgress } from "@material-ui/core";

const DELETE_BRAND = gql`
  mutation DeleteBrand($id: Int!, $clientLoginId: Int!) {
    deleteBrand(id: $id, clientLoginId: $clientLoginId) {
      status
      message
    }
  }
`;

const DeleteBrandModal = ({ open, onClose, brandId, clientLoginId, deleteBrand, refetchBrands , openSnackbar}) => {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    try {
      const res = await deleteBrand({
        variables: { id: brandId, clientLoginId },
      });
      if (res.data.deleteBrand.status) {
        onClose();
       
        refetchBrands();
        openSnackbar(`${res.data.deleteBrand.message}`);
       
      } else {
        onClose();
        openSnackbar(`${res.data.deleteBrand.message}`);
     
      }
    } catch (error) {
      console.error(error);
      // enqueueSnackbar(`Error: ${error.message}`, { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div style={{ width: "500px", padding: "20px", background: "white", margin: "auto", marginTop: "20vh", borderRadius:"10px" }}>
        <Typography variant="h6" gutterBottom style={{color:"#000", fontWeight:"bold"}}>
          Delete Brand?
        </Typography>
        <Typography style={{ marginBottom: "20px", marginTop:"10px" }} ariant="body1">Are you sure you want to delete this brand?</Typography>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "5px" }}>
          <Button variant="outlined" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button variant="contained" style={{
            borderRadius: 8,
            backgroundColor: '#f44336', 
            color: '#ffffff',
            '&:hover': {
              backgroundColor: '#e53935', 
            }
          }} onClick={handleDelete} disabled={loading}>
            {loading ? <CircularProgress size={24} /> : "Delete"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default graphql(DELETE_BRAND, {
  name: "deleteBrand", 
})(withSharedSnackbar(DeleteBrandModal));



// WEBPACK FOOTER //
// ./src/components/Pages/modalConfigure/DeleteBrandModal.jsx